import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Warehouse, ChevronRight } from "lucide-react";
import { api, errMsg, takeReturn } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PinForm } from "@/components/PinForm";
import { EntryShell } from "@/pages/Entry";
import { NewCellarForm, CellarModeTabs } from "@/components/NewCellarForm";

export default function CavePicker() {
  const navigate = useNavigate();
  const { user, enterCave, logout } = useAuth();
  const [caves, setCaves] = useState(null);
  const [pinFor, setPinFor] = useState(null);
  const [mode, setMode] = useState("existing");

  useEffect(() => {
    api.get("/caves/public").then((r) => setCaves(r.data)).catch(() => setCaves([]));
  }, []);

  const pick = async (c) => {
    if (user.role !== "owner") return setPinFor(c);
    try {
      await enterCave(c.id);
      navigate(takeReturn());
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <EntryShell>
      <p className="text-[#A89F91] mb-6">Hello {user.name}, choose a cellar.</p>
      {user.role === "owner" && <CellarModeTabs mode={mode} setMode={setMode} />}
      {mode === "new" ? <NewCellarForm needLogin={false} /> : (
      <>
      <div className="space-y-2 mb-8" data-testid="cave-picker-list">
        {(caves || []).map((c) => (
          <button key={c.id} onClick={() => pick(c)} data-testid={`pick-cave-${c.id}`}
            className={`w-full flex items-center gap-3 rounded-lg border px-4 py-4 text-left transition-colors ${user.cave_id === c.id || pinFor?.id === c.id ? "border-[#D4AF37]" : "border-[#2E252A] hover:border-[#4A3B43]"} bg-[#161214]`}>
            <Warehouse className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
            <span className="flex-1 text-[#F5F0EB]">{c.name}</span>
            <ChevronRight className="w-4 h-4 text-[#6E665D]" />
          </button>
        ))}
        {caves === null && <p className="font-mono text-sm text-[#6E665D]">Loading…</p>}
        {caves && !caves.length && <p className="text-[#6E665D]">No cellar yet.</p>}
      </div>
      {pinFor && <PinForm key={pinFor.id} caveId={pinFor.id} askName={false} onDone={() => navigate(takeReturn())} />}
      </>
      )}
      <button onClick={logout} className="mt-6 text-sm text-[#6E665D] hover:text-[#D4AF37]" data-testid="picker-logout-button">Sign out</button>
    </EntryShell>
  );
}
